import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Equipment_ds_equipment_warehouses_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { equipmentId: number }): 
  Promise<{ result: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, Equipment?: { Id?: number, LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.equipmentId)) {
      missingRequiredInParams.push('\'equipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_warehouses_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { equipmentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, Equipment?: { Id?: number, LookupCode?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.equipmentId)) {
      missingRequiredInParams.push('\'equipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_warehouses_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { equipmentId: number, $keys: { EquipmentId?: number, LocationContainerId?: number }[] }): 
  Promise<{ result: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, Equipment?: { Id?: number, LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.equipmentId)) {
      missingRequiredInParams.push('\'equipmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_warehouses_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      equipmentId: number    }) {
        if(isNil(inParams.equipmentId)) {
          return true; 
        }
      return false;
    }
}
